import React from 'react'
import { useQuery } from 'react-query'
import DataTable from '../../../UI/table/DataTable'
import StatusBadge from '../../../UI/statusBadge';
import TableActions from '../../../UI/table/TableActions';
import { getCuriosAttendance } from '../../../../MyApi/curior/index';

const CurioerAttendance = ({id}) => {
  const { data, isLoading } = useQuery(['getCuriosAttendance', id], () => getCuriosAttendance(id), { enabled: !!id });
  const shifts = data?.data?.shifts || [];

     const attendanceColumns = [
  {
    label: "اسم الوردية",
    accessor: "shift_template.name",
  },
  {
    label: "وقت البدء",
    accessor: "start_time",
  },
  {
    label: "وقت الانتهاء",
    accessor: "end_time",
  },
  {
    label: "الوقت المتوقع للانتهاء",
    accessor: "expected_end_time",
  },
  {
    label: "مفتوح",
    render: (row) => row.is_open ? "نعم" : "لا",
  },
  {
    label: "دقائق الإضافي",
    accessor: "overtime_minutes",
  },
  {
    label: "إجمالي الساعات",
    accessor: "total_hours",
  },
  {
    label: "إجمالي الطلبات",
    accessor: "total_orders",
  },
  {
    label: "إجمالي الأرباح",
    render: (row) => `${row.total_earnings} ج.م`,
  },
  {
    label: "متأخر",
    render: (row) => row.is_late ? "نعم" : "لا",
  },
  {
    label: "الحالة",
    render: (row) => (
      <StatusBadge
        status={row.is_open ? "active" : "inactive"}
        statusLabel={row.is_open ? "مفتوح" : "مغلق"}
      />
    ),
  },
  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
        show={`${process.env.PUBLIC_URL}/shifts/${row.id}`}
        viewPermission=""
      />
    ),
  },
];
  return (
    <div>
        <DataTable
         columns={attendanceColumns}
         data={shifts}
         isLoading={isLoading}
        />
    </div>
  )
}

export default CurioerAttendance
